var React = require('react');

class Overlay extends React.Component {
  constructor(props) {
    super(props);
    var className = (typeof(window) !== 'undefined') ? 'pubr-overlay' : 'pubr-overlay pubr-overlay--mounted pubr-overlay--complete';
    this.state = {
      className: className
    }
  }
  componentDidMount() {
    document.body.classList.add('pubr-overlay-mounted');
    setTimeout(() => {
      this.setState({
        className:'pubr-overlay pubr-overlay--mounted'
      });
    },10);
    setTimeout(() => {
      document.body.classList.add('pubr-overlay-complete');
      this.setState({
        className:'pubr-overlay pubr-overlay--mounted pubr-overlay--complete'
      });
    },600);
  }
  componentWillUnmount() {
    document.body.classList.remove('pubr-overlay-mounted');
    document.body.classList.remove('pubr-overlay-complete');
  }
  render() {
      return (
        <div className={this.state.className} aria-live="polite">
          <div className="pubr-overlay__inner">
            {this.props.children}
          </div>
        </div>
      );
  }
}

module.exports = Overlay;



// WEBPACK FOOTER //
// ./src/components/Overlay.js